import styled from '@emotion/styled'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { object } from 'prop-types'
import { Paper, CvsTextField } from '@components'
import { colors } from '@global/constants'
import { t } from '@lingui/core/macro'

const Text = styled(CvsTextField)`
  margin-top: 12px;
  margin-left: 4px;
  margin-right: 4px;
`

const StyledFormControlLabel = styled(FormControlLabel)`
  margin: 0 0 10px 0;
  display: flex;
  word-break: break-word;

  .MuiFormControlLabel-label {
    padding-right: 10px;
    display: inline-flex;
    align-items: center;
  }

  .MuiButtonBase-root {
    padding: 0 10px 0 0;
    display: inline-flex;
    align-self: flex-start;
  }
`

// coupling onchange for now because faster. Sorry future people.
export const TemplateFieldCard = ({ item = {}, assignment, onChange, index }) => {
  const readOnly = assignment.report_type === 'default' || item.readOnly

  const toggleIsHidden = () => {
    onChange({ ...item, isHidden: !item.isHidden, selected: !item.selected })
  }

  const onDisplayChange = value => {
    onChange({ ...item, display: value })
  }

  return (
    <Paper
      elevation={3}
      style={{
        padding: 12,
        height: 140,
        cursor: 'grab',
        position: 'relative',
        width: 198,
        userSelect: 'none',
      }}
    >
      <span style={{ color: colors.gray.main, position: 'absolute', top: 6, right: 6 }}>
        {index + 1}
      </span>
      <StyledFormControlLabel
        control={<Checkbox checked={item.selected} onChange={toggleIsHidden} disabled={readOnly} />}
        label={`Include ${item.name}`}
      />
      <Text
        margin="dense"
        label={t`Output label`}
        disabled={readOnly}
        onClick={e => e.stopPropagation()}
        value={item.display}
        onChange={({ target: { value } }) => onDisplayChange(value)}
      />
    </Paper>
  )
}

TemplateFieldCard.propTypes = {
  item: object,
}
